import React from "react"
import styled from "styled-components";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #FFF;
  align-items: center;
  margin: 0 auto;
  width: 100vw;
  padding-bottom: 0;
  min-height: 100vh;
  overflow: hidden;
  position: relative;
  color: #000000;
`

const Page: React.FC<
  React.HTMLAttributes<HTMLDivElement>
  > = ({ children }) => {
  return (
    <>
      <Container>
        {children}
      </Container>
    </>
  )
}

export default Page